'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _buttonNo = require('../layoutElements/svg/_buttonNo.vue');

var _buttonNo2 = _interopRequireDefault(_buttonNo);

var _buttonYes = require('../layoutElements/svg/_buttonYes.vue');

var _buttonYes2 = _interopRequireDefault(_buttonYes);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _TweenLite = require('../../../../node_modules/gsap/src/uncompressed/TweenLite.js');

var _TweenLite2 = _interopRequireDefault(_TweenLite);

require('../../../../node_modules/gsap/src/uncompressed/plugins/ScrollToPlugin');

var _loader = require('../layoutElements/svg/_loader.vue');

var _loader2 = _interopRequireDefault(_loader);

require('../../../../node_modules/gsap/src/uncompressed/easing/EasePack');

var _jquery = require('../../vendor/jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// set variables for the overlayer for the game
var gameContainer = document.querySelectorAll('.game');
// import custom jquery for the offset

var overlayer = document.querySelectorAll('.overlayer');

// set the position of the game container to scroll to

var matcherContainerPosition = (0, _jquery2.default)('#game').offset().top;

_vue2.default.transition('scaleOut', {
    css: false,
    leave: function leave(el, done) {
        var tl = new TimelineLite({
            onComplete: done
        });

        tl.to(el, .3, {
            scale: 1.5
        }).to(el, .3, {
            scale: 0
        });
    },
    leaveCancelled: function leaveCancelled(el) {
        if (this.tl) {
            this.tl.kill();

            TweenMax.set(el, {
                opacity: 1
            });
        }
    }
});

_vue2.default.transition('scaleIn', {
    css: false,
    enter: function enter(el, done) {
        var tl = new TimelineLite({
            onComplete: done,
            delay: .6
        });

        tl.fromTo(el, .3, {
            opacity: 0,
            scale: 0
        }, {
            opacity: 1,
            scale: 1.5
        }).to(el, .3, {
            scale: 1
        });
    },
    enterCancelled: function enterCancelled(el) {
        if (this.tl) {
            this.tl.kill();
            _TweenLite2.default.set(el, {
                opacity: 1
            });
        }
    }
});

exports.default = {
    route: {
        activate: function activate() {}
    },
    components: {
        buttonNo: _buttonNo2.default,
        buttonYes: _buttonYes2.default,
        loader: _loader2.default
    },
    data: function data() {
        // set the default data for this component
        return {
            question: "",
            option1: "",
            option2: "",
            yes: "",
            no: "",
            query: [],
            show: true,
            transitionName: 'fade',
            image: '',
            loading: true,
            startGame: false
        };
    },
    ready: function ready() {
        // request the first question with an empty data object
        this.requestMatcher({});

        // scroll to the beginning of the game
        _TweenLite2.default.to(window, 0.2, {
            scrollTo: {
                y: matcherContainerPosition * (1 - 0.1)
            }
        });

        // add the necessary classes to the overlay to make the step stand out a bite

        gameContainer[0].classList.add('game--step2');
        overlayer[0].classList.add('overlayer--active');
    },
    computed: {
        /**
         * Set current question
         * @param string    question
         * */
        addQuestion: {
            set: function set(question) {
                this.question = question;
            }
        },
        /**
         * Set current answers
         * @param object    answers
         */
        addAnswers: {
            set: function set(answers) {
                this.yes = answers.yes;
                this.no = answers.no;
            }
        },
        /**
         * Update the query array
         * @param string    option
         */
        setQuery: {
            set: function set(option) {
                this.query.push(option);
            }
        }
    },
    methods: {
        /**
         * Event handler for button Yes
         */
        selectYes: function selectYes(event) {
            this.setQuery = this.yes;
            var data = {
                q: this.query.join('-')
            };

            self = this;

            var buttonTl = new TimelineLite({
                onComplete: function onComplete() {
                    self.$set('transitionName', 'slideRight');
                    // hide the current step for transition usage
                    self.$set('show', false);
                    self.$set('loading', true);
                    self.requestMatcher(data);
                }
            });

            buttonTl.to(event.currentTarget, 0.1, {
                y: -20
            }).to(event.currentTarget, 0.2, {
                y: 0,
                ease: Bounce.easeOut
            });
        },
        /**
         * Event handler for button No
         */
        selectNo: function selectNo(event) {
            this.setQuery = this.no;
            var data = {
                q: this.query.join('-')
            };

            var self = this;

            var buttonTl = new TimelineLite({
                onComplete: function onComplete() {
                    // set the new transition
                    self.$set('transitionName', 'slideLeft');

                    // hide the current step for trnasition usage
                    self.$set('loading', true);
                    self.$set('show', false);
                    self.requestMatcher(data);
                }
            });

            buttonTl.fromTo(event.currentTarget, 0.3, {
                x: -5
            }, {
                x: 5,
                clearProps: 'x',
                ease: RoughEase.ease.config({ strength: 8, points: 20, template: Linear.easeNone, randomize: false })
            });
        },
        /**
         * Send post requests to the matcher route
         * @param data
         */
        requestMatcher: function requestMatcher(data) {
            this.$http.post('http://florette-speeddating.dev/matcher', data).then(function (response) {
                // success callback
                //console.log(response)
                if (response.data.status == 'done') {

                    // remove the overlay before going to the next step
                    gameContainer[0].classList.remove('game--step2');
                    overlayer[0].classList.remove('overlayer--active');

                    this.$route.router.go({
                        name: 'step2',
                        params: {
                            one: response.data.recipes[0].id,
                            two: response.data.recipes[1].id,
                            three: response.data.recipes[2].id
                        }
                    });
                } else {
                    // enable the step for transition usage
                    this.$set('show', true);
                    var responseData = response.data,
                        answers = {
                        yes: responseData.yes,
                        no: responseData.no
                    };

                    this.addQuestion = responseData.question;
                    this.addAnswers = answers;
                    // set the current image
                    this.$set('image', 'assets/images/htmlimages/ingredients/' + responseData.image);
                }
            }, function (response) {
                // error callback
                // do some error handling ?
            });
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <div class=\"container game__container text-center gameIntro\">\n        <h1 class=\"game__title h5 text--alternative\">\n            Glaubst du an Liebe auf den Ersten Biss?\n        </h1>\n        <p class=\"game__intro\">\n            Wer ist dein perfekter (Salat-)Match? Finde es jetzt spielerisch heraus. <br> Du bist nur zehn Klicks von deinem neuen Lieblingsrezept entfernt.\n        </p>\n    </div>\n    <div class=\"matcher__image\">\n        <figure class=\"matcher__figure\" v-if=\"show\" :transition=\"transitionName\" v-touch:swipeleft=\"selectNo()\" v-touch:swiperight=\"selectYes()\">\n            <div class=\"matcher__question\" v-show=\"startGame\" transition=\"scaleIn\">{{ question }}</div>\n            <button class=\"matcher__cta\" @click=\"startGame = true\" v-if=\"!startGame\" transition=\"scaleOut\" onclick=\"ga('send', 'event', 'Button', 'clicked',  'Game started New Version', 1);\">\n                Los geht's\n            </button>\n            <loader :loading=\"loading\"></loader>\n            <img v-bind:src=\"image\" alt=\"\" v-spinner=\"['image', image]\" class=\"intrinsic__item matcher__intrinsicItem\" :class=\"{'game__hold': !startGame}\">\n            <figcaption class=\"matcher__figcaption\">\n                <div class=\"buttons\" v-show=\"startGame\" transition=\"scaleIn\">\n                    <button class=\"matcher__button matcher__buttons-no button--noStyle\" @click=\"selectNo($event)\">\n\n                        <div class=\"matcher__buttonWrapper\">\n                            <button-no></button-no>\n                        </div>\n\n\n                    </button>\n                    <button class=\"matcher__button matcher__buttons-yes button--noStyle\" @click.prevent=\"selectYes($event)\">\n\n                        <div class=\"matcher__buttonWrapper\">\n                            <button-yes></button-yes>\n                        </div>\n                    </button>\n                </div>\n            </figcaption>\n        </figure>\n    </div>\n</div>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-6b423eae", module.exports)
  } else {
    hotAPI.update("_v-6b423eae", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}